import { render, staticRenderFns } from "./ResetOtp.vue?vue&type=template&id=320aa85f"
import script from "./ResetOtp.vue?vue&type=script&lang=js"
export * from "./ResetOtp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports